export const DEFAULT_NUMBER = 0; 